<template>
  <v-dialog
    :value="isCreateInboxMessageModalOpen"
    width="600"
    @input="inputCreateInboxMessageModal"
  >
    <v-card class="rounded-lg">
      <v-card-title class="justify-center">
        <span class="text-h6 grey--text text--darken-3 font-weight-medium">
          {{ $t('inbox.add.title') }}
        </span>
      </v-card-title>
      <v-divider />
      <v-card-text class="mt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="inboxMessage.name"
                :label="$t('inbox.add.action')"
                class="rounded-lg"
                color="#2661FF"
                outlined
                dense
                clearable
                required
                :rules="rules.nameRules"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="inboxMessage.description"
                :label="$t('inbox.add.description')"
                class="rounded-lg"
                color="#2661FF"
                outlined
                dense
                required
                no-resize
                :rules="rules.descriptionRules"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="inboxMessage.organization_id"
                :items="organizations"
                item-text="name"
                item-value="id"
                :label="$t('inbox.add.organization')"
                class="rounded-lg"
                color="#2661FF"
                outlined
                dense
                required
                :rules="rules.organizationRules"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="py-0 pb-2">
        <v-spacer />
        <v-btn
          color="grey darken-1"
          text
          @click="toggleCreateInboxMessageModal(false)"
        >
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="#2661FF" text @click="createInboxMessage">
          {{ $t('general.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'CreateInboxMessage',
  data() {
    return {
      valid: true,
      loading: false,
      inboxMessage: {
        name: null,
        description: null,
        organization_id: null,
        assigned_user_id: null
      },
      rules: {
        nameRules: [
          v => !!v || this.$t('inbox.add.rules.name.required'),
          v => (v && v.length <= 50) || this.$t('inbox.add.rules.name.max')
        ],
        descriptionRules: [
          v => !!v || this.$t('inbox.add.rules.description.required'),
          v =>
            (v && v.length <= 255) || this.$t('inbox.add.rules.description.max')
        ],
        organizationRules: [
          v => !!v || this.$t('inbox.add.rules.organization.required')
        ]
      }
    }
  },
  computed: {
    ...mapState({
      isCreateInboxMessageModalOpen: state =>
        state.inbox.isCreateInboxMessageModalOpen,
      organizations: state => state.organization.organizations
    })
  },
  methods: {
    ...mapActions({
      createInboxMessageAction: 'inbox/createInboxMessage'
    }),
    ...mapMutations({
      toggleCreateInboxMessageModal: 'inbox/toggleCreateInboxMessageModal'
    }),
    inputCreateInboxMessageModal(args) {
      if (!args) {
        this.toggleCreateInboxMessageModal(false)
      }
    },
    async createInboxMessage() {
      const validForm = await this.$refs.form.validate()

      if (!validForm) {
        return
      }

      await this.createInboxMessageAction(this.inboxMessage)

      this.toggleCreateInboxMessageModal(false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
